import { formatMoney } from "../../toll/money";
import { getCampaignThemeImages, getCampaignThemeFallback } from '../../toll/campaignThemeVisual';
import { MyColor } from "../../config/myStyle";
import { fundraising_campaign_smaller_enter_button } from "../../imgs";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { GetDonationRes } from "../../api";
import { useTranslation } from "react-i18next";

type MyRecorDonationItem = {
  donation: GetDonationRes
}

const MyRecorDonationItem = (props: MyRecorDonationItem) => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const donation = props.donation
  const campaign = props.donation.campaign
  const profileUrl = useMemo(() => {
    return getCampaignThemeImages(campaign).profile
  }, [campaign?.campaignAssets])

  const onClick = () => {
    campaign && navigate(`/my-record/${campaign?.id}`)
  }
  return (
    <div style={{ position: 'relative' }}>
      <div className="bg-[white] rounded-full flex items-center p-[6px]" style={{ borderWidth: 2, borderColor: MyColor.sub }}>
        <img alt={campaign?.title || ""} src={profileUrl} onError={event => { event.currentTarget.onerror = null; event.currentTarget.src = getCampaignThemeFallback().profile; }} className="size-[75px] rounded-full object-cover" />
        <div className="flex-1 ml-[10px]">
          <div className="line-clamp-1 text-[17px] font-[600]" style={{ color: MyColor.blue }}>{campaign?.title}</div>
          <div className="line-clamp-1 text-[13px] text-[rgba(0,0,0,0.6)]">{t("my_record_donation_amount.your_donation_amount")}</div>
          <div className="line-clamp-1 text-[22px] font-[700] text-[rgba(0,0,0,0.8)]" style={{ lineHeight: 1 }}> HK$ {formatMoney(donation.amount)}</div>
        </div>
      </div>
      <img onClick={onClick} className="size-[32px]" style={{ position: 'absolute', bottom: 0, right: 0 }} src={fundraising_campaign_smaller_enter_button} />
    </div>
  );
}

export default MyRecorDonationItem;
